// Core
import React, { useState, useRef } from "react"
import addToMailchimp from "gatsby-plugin-mailchimp"
import { localiseString } from "../../utils/localiseString"

// Style
import styles from "./newsletterForm.module.scss"

import { SlideMaskText } from "../slideMaskText"

const NewsletterForm = ({ theme }) => {
  const [active, setActive] = useState(false),
    [success, setSuccess] = useState(false),
    [error, setError] = useState(false)

  const input = useRef(null)

  const focusIn = () => {
    setActive(true)
  }

  const focusOut = () => {
    if (!input.current.value) setActive(false)
  }

  const handleForm = e => {
    if (e) e.preventDefault()

    if (!input.current.value) {
      input.current.focus()
      return
    }

    addToMailchimp(input.current.value).then(data => {
      if (data.result === "success") setSuccess(true)
      if (data.result === "error") setError(true)
    })
  }

  return (
    <form
      className={`${styles.form} ${theme === "light" ? styles.light : ""} ${
        success ? styles.success : ""
      } ${error ? styles.error : ""}`}
      onSubmit={handleForm}
    >
      <p className={`${styles.response} ${styles.successResponse} mono`}>
        {localiseString("Thanks for Subscribing!")}
      </p>
      <p className={`${styles.response} ${styles.errorResponse} mono`}>
        {localiseString("There has been an error submitting your email address.")}
      </p>
      <div className={`${styles.field} ${active ? styles.active : ""}`}>
        <label htmlFor="email-address">{localiseString("Enter your Email")}</label>
        <input
          onFocus={focusIn}
          onBlur={focusOut}
          id="email-address"
          name="email-address"
          type="email"
          ref={input}
        />
      </div>
      <div className={styles.submit}>
        <button className={`button`} type="submit">
          <SlideMaskText text={localiseString("Sign me up")} />
        </button>
      </div>
    </form>
  )
}

export default NewsletterForm
